module.exports = __webpack_public_path__ + "img/gift-box-explode.a3768789.gif";